export const CalendarConfig = {
    name            : 'Calendar',
    menuName        : 'Calendar',
    icon            : 'i5-calendar',
    image           : 'calendar',
    iconSvg         : 'isvg-view-calendar',
    url             : 'calendar',
    stringId        : 'calendar',
    description     : 'Monthly/Weekly Calendar displaying events, milestones, and deadlines.',
    inheritance     : true,
    hasTemplates    : true,
    canBeInProject  : true,
}

export const PROJECT_CALENDAR_CONFIG = {
    ...CalendarConfig,
    // key2: "newValue2",  // Replacing the value for key2
}
